import React from 'react';
import {
  FluentProvider,
  teamsLightTheme,
  Button,
} from '@fluentui/react-components';
import { CheckmarkCircle24Regular } from '@fluentui/react-icons';
import { useNavigate, useLocation } from "react-router-dom";

const SuccessScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // selectedForm should contain id, surveyCodedId, and name from FormSelectionScene
  const selectedForm = location.state?.selectedForm || { id: 0, surveyCodedId: "", name: "QF-802" };
  const referenceCode = location.state?.referenceCode || "";
  const clinicalFormUrl = location.state?.clinicalFormUrl || "";
  
  const currentDateTime = new Date().toLocaleString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
  
  const handleViewDocument = () => {
    if (clinicalFormUrl) {
      window.open(clinicalFormUrl, '_blank');
    } else {
      console.warn('No clinical form URL available');
    }
  };
  
  return (
    <FluentProvider theme={teamsLightTheme}>
      <div style={{ padding: 20, maxWidth: 400, minHeight: '90vh' }}>
        <div>
          <Button appearance="subtle" icon={<span style={{display:'inline-block',transform:'rotate(180deg)'}}>&#8594;</span>} onClick={() => navigate(-1)} aria-label="Back" />
        </div>
        <div style={{ marginTop: 16 }}>
          <div style={{ fontWeight: 'bold', fontSize: '0.875rem' }}>
            Health Partners Note Assistant
          </div>
          <div style={{ fontWeight: 600, fontSize: '1.1rem' }}>
            {referenceCode}
          </div>
          <div style={{ fontWeight: 600, marginTop: 4 }}>{selectedForm.name}</div>
        </div>

        <div
          style={{
            backgroundColor: '#EFFFF4',
            color: '#0F703E',
            borderRadius: 6,
            padding: '12px',
            display: 'flex',
            alignItems: 'start',
            gap: 8,
            marginTop: 24,
            fontSize: '0.875rem',
            border: '1px solid #A4D7B5',
          }}
        >
          <CheckmarkCircle24Regular />
          <div>
            <strong>Notes Successfully Generated</strong><br />
            The {selectedForm.name || 'form'} has been successfully<br />
            created on {currentDateTime}
          </div>
        </div>

        <div style={{ marginTop: 32, textAlign: 'center' }}>
          <Button 
            appearance="primary" 
            onClick={handleViewDocument}
            disabled={!clinicalFormUrl}
          >
            View Document
          </Button>
        </div>
      </div>
    </FluentProvider>
  );
};

export default SuccessScreen;
